import axios from "axios";
import { PaymentsType } from "types/PaymentsI";
import { getHeaders } from "./AuthHeader";
const API_URL = process.env.REACT_APP_API_URL;

export async function getPaymentGetwayService(items, custom_credit_value, client_id: string, payment_type: string, lang: any, product_id: string | null = null, valid_from_date: string | null = null) {

    try {   
        let url_object = new URL(window.location.href)
        // let return_url = 
        const payment_search_params = new URLSearchParams();

        payment_search_params.append('payment_type', payment_type)
        payment_search_params.append('client_id', client_id)
    
        if (product_id !== null) {
            payment_search_params.append(
                'memberships', 
                JSON.stringify({
                    id: product_id.toString(),
                    valid_from: valid_from_date
                })
                // product_id.toString()
                )
        }

        payment_search_params.forEach((value, key) => {
            url_object.searchParams.append(key, value)
        })
        let return_url = url_object.toString()

        const response = await axios.post(
            API_URL + "/get_payment_getway",
            {
                items: items,
                amount: parseFloat( custom_credit_value ) * 100,
                payment_type: payment_type,
                client_id: client_id, 
                lang: lang,
                return_url: return_url,
                return_params: payment_search_params.toString()
            },
            {
                headers: getHeaders()
            }
        )

        // console.log(response);
        if (!('gw_url' in response.data)) {
            return 'no_url'
        }

        // console.log("URL:");
        // console.log(response.data.gw_url);
        
        return response.data


    } catch(error) {
        // console.log(error);
        return 'error'
    }
}